/**
 * @generated SignedSource<<f41bdcfca609bddd5c19f0b40062ae7a>>
 * @relayHash e644cfdb7754aa958cdfe9341fe1e581
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-trade/579.0.0-2026-10-05T13:12:26.751Z/followPageMutation

import { ConcreteRequest } from 'relay-runtime';
export type FavoriteAction = "ADD" | "REMOVE" | "%future added value";
export type FavoritePageInput = {
  action: FavoriteAction;
  clientMutationId?: string | null;
  favoriteId?: string | null;
  name?: string | null;
  page: string;
  query?: string | null;
  type: string;
  userId: string;
};
export type followPageMutation$variables = {
  input: FavoritePageInput;
};
export type followPageMutation$data = {
  readonly favoritePage: {
    readonly user: {
      readonly favorites: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly anchor: {
              readonly sourceId: string | null;
            } | null;
            readonly serviceId: string | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};
export type followPageMutation = {
  response: followPageMutation$data;
  variables: followPageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "types",
    "value": [
      "DESIGNER"
    ]
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Anchor",
  "kind": "LinkedField",
  "name": "anchor",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sourceId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "followPageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "FavoritePagePayload",
        "kind": "LinkedField",
        "name": "favoritePage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*:: as any*/),
                "concreteType": "favoritesConnection",
                "kind": "LinkedField",
                "name": "favorites",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "favoritesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Favorite",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*:: as any*/),
                          (v4/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "favorites(types:[\"DESIGNER\"])"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "followPageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "FavoritePagePayload",
        "kind": "LinkedField",
        "name": "favoritePage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*:: as any*/),
                "concreteType": "favoritesConnection",
                "kind": "LinkedField",
                "name": "favorites",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "favoritesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Favorite",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*:: as any*/),
                          (v4/*:: as any*/),
                          (v5/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "favorites(types:[\"DESIGNER\"])"
              },
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-trade/579.0.0-2026-10-05T13:12:26.751Z/followPageMutation",
    "metadata": {},
    "name": "followPageMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "f7a969b846799d9136e6f11749d6c98d";

export default node;
